export const SET_PARAMETER = 'SET_PARAMETER';
export const CLEAR_PARAMETER = 'CLEAR_PARAMETER';
